import { SET_FULL_SCREEN_INTELLEGANCE_CONTROL } from "../actions/intelligenceControlAction";

const initialState = {
  fullScreen: false,
};

const intelligenceControlReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FULL_SCREEN_INTELLEGANCE_CONTROL: {
      return Object.assign({}, state, {
        fullScreen: action.fullScreen,
      });
    }
    default:
      return state;
  }
};

export default intelligenceControlReducer;
